const passwordRegexPattern = "^(?=.*[a-zæøåäöüßéèàùêëïîôûçñ])(?=.*[A-ZÆØÅÄÖÜÉÈÀÙÊËÏÎÔÛÇÑ])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?~`§½¶°±€£¥¢©®™℗])[A-Za-zæøåäöüßéèàùêëïîôûçñÆØÅÄÖÜÉÈÀÙÊËÏÎÔÛÇÑ\\d!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?~`§½¶°±€£¥¢©®™℗]{8,}$";

export const passwordRegex = new RegExp(passwordRegexPattern);
